import ResetForgotPassword from './resetforgotpassword-view';

export default ResetForgotPassword;
